import { styled } from '@mui/material/styles';
import { ModalBase } from '@components/Modal';
import { RadioButtonsGroup } from '@components/RadioButtonsGroup';
import PhoneInput from '@components/PhoneInput';

export const StyledRadioButtons = styled(RadioButtonsGroup)({
    marginTop: '16px',
    marginBottom: '24px',
});

export const StyledPhoneInput = styled(PhoneInput)({
    marginBottom: '8px',
});

export const FullScreenModal = styled(ModalBase)({
    '& .modal-base-paper': {
        outline: 'none',
        width: 'calc(100% - 32px)',
        height: 'calc(var(--100vh) - 32px)',
    },
    '& .modal-base-content': {
        padding: 16,
    },
});

export const cellStyles = { maxWidth: '222px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' };
